/** Keys shared with legacy PHP / bookmarked state — keep in sync app-wide. */
export const PLAYLIST_STORAGE_ID = 'currentPlaylistId';
export const PLAYLIST_STORAGE_NAME = 'currentPlaylistName';

/** Dispatched after auth `persist()` clears or session rewrites playlist keys. */
export const PLAYLIST_STORAGE_SYNC_EVENT = 'iptv-playlist-storage-sync';

export function readStoredPlaylistSelection(): { id: string | null; name: string } {
  try {
    const raw = localStorage.getItem(PLAYLIST_STORAGE_ID);
    const id = raw && raw.trim() ? raw : null;
    const name = localStorage.getItem(PLAYLIST_STORAGE_NAME) || '';
    return { id, name };
  } catch {
    return { id: null, name: '' };
  }
}

export function writeStoredPlaylistSelection(id: string | null, name: string): void {
  try {
    if (id == null || id === '') {
      localStorage.removeItem(PLAYLIST_STORAGE_ID);
      localStorage.removeItem(PLAYLIST_STORAGE_NAME);
      return;
    }
    localStorage.setItem(PLAYLIST_STORAGE_ID, String(id));
    localStorage.setItem(PLAYLIST_STORAGE_NAME, name);
  } catch {
    /* ignore */
  }
}

/**
 * Removes the active playlist from localStorage.
 * Call when auth session starts or ends so another account never keeps the previous user's selection.
 */
export function clearStoredPlaylistSelection(): void {
  writeStoredPlaylistSelection(null, '');
}

export function dispatchPlaylistStorageSync(): void {
  try {
    window.dispatchEvent(new CustomEvent(PLAYLIST_STORAGE_SYNC_EVENT));
  } catch {
    /* ignore */
  }
}
